export default __webpack_public_path__ + "static/media/by.d48d4b75.svg";